import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.2 2.2a.683.683 0 0 1 .968 0l12.457 12.485.04.04 2.1 2.104a.687.687 0 0 1 0 .97.683.683 0 0 1-.968 0l-1.659-1.662-.103.085a.683.683 0 0 1-.962-.102.687.687 0 0 1 .093-.957l-1.352-1.355a.683.683 0 0 1-.946-.146.69.69 0 0 1-.009-.811l-2.003-2.008v4.799a1.34 1.34 0 0 1-.902 1.423 1.33 1.33 0 0 1-1.571-.59l-2.6-3.351H3.494A1.494 1.494 0 0 1 2 11.625v-3.25a1.5 1.5 0 0 1 1.495-1.499h1.287l.488-.629L2.2 3.171a.687.687 0 0 1 0-.97m4.046 5.025-.589.758a.68.68 0 0 1-.54.265H3.495a.127.127 0 0 0-.127.127v3.25a.127.127 0 0 0 .127.127h1.622c.211 0 .41.098.54.265l2.83 3.647V9.471zm2.241-2.889-.341.44a.683.683 0 0 1-.96.12.687.687 0 0 1-.12-.962l.317-.409a1.334 1.334 0 0 1 2.292-.01c.152.254.215.55.18.844v1.578a.685.685 0 1 1-1.368 0zm5.586-.456a.683.683 0 0 1 .962-.102 8.016 8.016 0 0 1 2.095 9.854.684.684 0 1 1-1.22-.623 6.64 6.64 0 0 0-1.735-8.165.687.687 0 0 1-.102-.964m-2.205 2.458a.683.683 0 0 1 .958-.137 4.75 4.75 0 0 1 1.812 4.686.684.684 0 1 1-1.344-.256 3.38 3.38 0 0 0-1.29-3.333.687.687 0 0 1-.136-.96",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }